
(function ($) {
$.fn.extend({
insertAtCaret: function (myValue) {
var $t = $(this)[0];

if (document.selection) {
this.focus();
sel = document.selection.createRange();
sel.text = myValue;
this.focus();
}

else if ($t.selectionStart || $t.selectionStart == '0') {
var startPos = $t.selectionStart;
var endPos = $t.selectionEnd;
var scrollTop = $t.scrollTop;
$t.value = $t.value.substring(0, startPos) + myValue + $t.value.substring(endPos, $t.value.length);
this.focus();
$t.selectionStart = startPos + myValue.length;
$t.selectionEnd = startPos + myValue.length;
$t.scrollTop = scrollTop;
} else {
this.value += myValue;
this.focus();
}
}
});
})(jQuery);
import csrJS from './csr.js'; 
import XTextarea from 'vux/src/components/x-textarea/index.vue'

export default {
components: {
XTextarea
},
mixins: [csrJS],
data() {
return {
csrPhoto: './static/images/csr_photo.png', // 客服头像
expression: false,
/* 鼠标右键相关 */
shortcutMenu: false, // 右键选项菜单 开关
top: 0, // 定位
left: 0, // 定位
withdrawalmessageIndex: -1, //  当前选中需要撤回的消息下标
SendSettings0ptions: [

{
num: 1,
words: '按Enter键发送消息'
},
{
num: 2,
words: '按Ctrl+Enter键发送消息'
}
],
sendingMethod: 2, // 当前设置的快捷键 标识
showDropdown: false 
};
},
computed: {
pcCsrShow() {
return this.$store.state.pcCsrShow;
}
},
watch: {
pcCsrShow(newVal) {
this.msgListHeight = 0;
this.isPrevious = true;


if (newVal) {
let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
if (userInfo && userInfo.accountId) {

this.user.accountId = userInfo.accountId;
this.user.img = userInfo.poster || '';
this.user.name = userInfo.displayName || '';

this.logCurrentCsr(); 
this.loadMsgList(1); 
}


if (sessionStorage.getItem('customerToGoods')) {
this.customerToGoods = JSON.parse(sessionStorage.getItem('customerToGoods'));
} else {
this.customerToGoods = {};
}


if (localStorage.getItem('sendingMethod')) {
this.sendingMethod = localStorage.getItem('sendingMethod');
} else {
this.sendingMethod = 1;
localStorage.setItem('sendingMethod', JSON.stringify(this.sendingMethod));
}


this.msgListTouchMonitor();
this.upslideLoading();
setTimeout(() => {
$('.viewer-container').click(() => {
this.$el.querySelector('.v-viewer').$viewer.hide();
});
}, 1000);
this.judgeDeviceType = this.$judgeDeviceType();

} else {
$('#msgList').off();
}
},

sendingMethod(newVal) { }
},

methods: {
/*------右键菜单列表Start------*/

openMenu(e, entity_, index_) {
if (entity_.self) {
this.withdrawalmessageIndex = index_;
const menuMinWidth = 105;
const offsetLeft = this.$el.getBoundingClientRect().left; 
const offsetWidth = this.$el.offsetWidth; 
const maxLeft = offsetWidth - menuMinWidth; 
const left = e.clientX - offsetLeft; 

if (left > maxLeft) {
this.left = maxLeft;
} else {
this.left = left;
}

this.top = e.clientY - 60; 
this.shortcutMenu = true;
$('#msgList').css('overflow', 'hidden'); 
}
},

closeMenu() {
this.shortcutMenu = false;
$('#msgList').css('overflow', 'auto'); 
this.withdrawalmessageIndex = -1;
},

messageWithdrawal() {
let that = this;
if (this.withdrawalmessageIndex != -1) {
var index_ = that.withdrawalmessageIndex;
} else {
this.$message.error('撤回失败，请刷新列表重试');
}
if (that.msgList[index_].messageStatus == 0 && that.msgList[index_].customerServiceConsultId) {
console.log('消息主键' + that.msgList[index_].customerServiceConsultId);
var data = {
customerServiceConsultId: that.msgList[index_].customerServiceConsultId 
};
that.$axios.post('/api/v1.0/lonbonShop/revocation', that.qs.stringify(data)).then(function (res) {
if (res.status == 200) {
console.log('删除消息成功');
for (let index = 0; index < that.contactList.length; index++) {
if (that.contactList[index].accountId == that.currentContact.accountId) {
if (that.msgList[index_].self) {
that.contactList[index].latestNews = '[你撤回了一条消息]';
} else {
that.contactList[index].latestNews = '[对方撤回了一条消息]';
}
}
}
that.refreshContactListsessionStorage();
that.msgList[index_].messageStatus = 1;
that.shortcutMenu = false;
$('#msgList').css('overflow', 'auto'); 
}
});
}
},
/*右键菜单列表End*/


closeCsr() {
this.$store.state.pcCsrShow = false;
},

showChooseMenu() {
if (this.showDropdown) {
this.showDropdown = false;
} else {
this.showDropdown = true;
}
},

chooseSendMethod(method_) {
localStorage.setItem('sendingMethod', JSON.stringify(method_));
if (localStorage.getItem('sendingMethod')) {
this.sendingMethod = localStorage.getItem('sendingMethod');
} else {
this.sendingMethod = 1;
}
},

keyDown(e) {
if (this.sendingMethod == 1) {
if (e.ctrlKey && e.keyCode == 13) {

$('#messageInput textarea').insertAtCaret('\n');
} else {

this.saveConsultMsg();
e.returnValue = false;
return false;
}
} else {
if (e.ctrlKey && e.keyCode == 13) {

this.saveConsultMsg();
} else {

}
}
}
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/customerService/csrDialog.vue